// import React, { useState } from 'react'
// import { useEffect } from 'react'

// const Pagination = ({page,onChangePagination,total}) => {


//     const [counter,setCounter]=useState(1)

//     const onClickButton=(type)=>{
//         if(type==='prev'){
//             if(counter===1){
//                 setCounter(1)
//             }else{
//                 setCounter(counter-1)
//             }
//         }
        
//         if(type==='next'){
//             if(Math.ceil(total/page)===counter)
//             {
//                 setCounter(counter)
//             }
//             else{
//                 setCounter(counter+1)
//             }
//         }
//         if(type==='last'){
//             setCounter(Math.ceil(total/page))
//         }
//         if(type==='first'){
//             setCounter(1)
//         }

//     }
//     useEffect(()=>{
//         const end=counter*page
//         const start=end-page
//         onChangePagination(start,end)
//     },[counter])

//   return (
//     <div className='container'>
//         <div className='d-flex justify-content-between'>
//             <button type='button' className='btn-primary' onClick={()=> onClickButton('first')}>First-Page</button>
//              <div>
//                 <button type='button' className=' ms-5' onClick={()=> onClickButton('prev')}>Previous</button>
//                 <button type='button' className=''>{counter}</button>
//                 <button type='button' className='' onClick={()=>onClickButton('next')}>Next.......</button>
//              </div>
//             <button type='button' className=' ms-5' onClick={()=>onClickButton('last')}>Last-Page</button>
//         </div>
//     </div>
//   )
// }

// export default Pagination


// import React, { useState, useEffect } from 'react';

// const Pagination = ({ page, onChangePagination, total }) => {
//   // ✅ Calculate initial counter from sessionStorage if available
//   const getSavedPage = () => {
//     const savedStart = Number(sessionStorage.getItem("member_page_start")) || 0;
//     return Math.floor(savedStart / page) + 1;
//   };

//   const [counter, setCounter] = useState(getSavedPage);

//   // Sync counter if total or saved page changes externally
//   useEffect(() => {
//     const savedStart = Number(sessionStorage.getItem("member_page_start")) || 0;
//     const currentCalculatedPage = Math.floor(savedStart / page) + 1;
//     if (counter !== currentCalculatedPage && currentCalculatedPage > 0) {
//       setCounter(currentCalculatedPage);
//     }
//   }, [total]);

//   const onClickButton = (type) => {
//     let newCounter = counter;
//     const maxPage = Math.ceil(total / page) || 1;

//     if (type === 'prev') {
//       newCounter = counter > 1 ? counter - 1 : 1;
//     } else if (type === 'next') {
//       newCounter = counter < maxPage ? counter + 1 : counter;
//     } else if (type === 'last') {
//       newCounter = maxPage;
//     } else if (type === 'first') {
//       newCounter = 1;
//     }

//     setCounter(newCounter);
//   };

//   useEffect(() => {
//     const end = counter * page;
//     const start = end - page;
//     onChangePagination(start, end);
//   }, [counter]);

//   return (
//     <div className='container'>
//       <div className='d-flex justify-content-between align-items-center'>
//         <button type='button' className='btn btn-primary btn-sm' onClick={() => onClickButton('first')}>First-Page</button>
//         <div>
//           <button type='button' className='btn btn-secondary btn-sm ms-2 me-2' onClick={() => onClickButton('prev')}>Previous</button>
//           <span className='fw-bold px-3 py-1 border rounded bg-white'>{counter}</span>
//           <button type='button' className='btn btn-secondary btn-sm ms-2 me-2' onClick={() => onClickButton('next')}>Next</button>
//         </div>
//         <button type='button' className='btn btn-primary btn-sm ms-2' onClick={() => onClickButton('last')}>Last-Page</button>
//       </div>
//     </div>
//   );
// };

// export default Pagination;


import React, { useState, useEffect } from 'react';

const Pagination = ({ page, onChangePagination, total }) => {
  const getSavedPage = () => {
    const savedStart = Number(sessionStorage.getItem("member_page_start")) || 0;
    return Math.floor(savedStart / page) + 1;
  };

  const [counter, setCounter] = useState(getSavedPage);
  const [inputVal, setInputVal] = useState(getSavedPage().toString());

  const totalPages = Math.ceil(total / page) || 1;

  // Sync state if total or sessionStorage changes externally
  useEffect(() => {
    const savedStart = Number(sessionStorage.getItem("member_page_start")) || 0;
    const currentCalculatedPage = Math.floor(savedStart / page) + 1;
    if (counter !== currentCalculatedPage && currentCalculatedPage > 0) {
      setCounter(currentCalculatedPage);
      setInputVal(currentCalculatedPage.toString());
    }
  }, [total]);

  // Keep the input value in sync when counter changes via buttons
  useEffect(() => {
    setInputVal(counter.toString());
  }, [counter]);

  const onClickButton = (type) => {
    let newCounter = counter;

    if (type === 'prev') {
      newCounter = counter > 1 ? counter - 1 : 1;
    } else if (type === 'next') {
      newCounter = counter < totalPages ? counter + 1 : counter;
    } else if (type === 'last') {
      newCounter = totalPages;
    } else if (type === 'first') {
      newCounter = 1;
    }

    setCounter(newCounter);
  };

  // Trigger page change whenever counter state updates
  useEffect(() => {
    const end = counter * page;
    const start = end - page;
    sessionStorage.setItem("member_page_start", start);
    onChangePagination(start, end);
  }, [counter]);

  // Handle direct page typing in middle input
  const handlePageInputChange = (e) => {
    setInputVal(e.target.value);
  };

  const handlePageSubmit = (e) => {
    if (e.key === 'Enter' || e.type === 'blur') {
      let pageNum = parseInt(inputVal, 10);

      if (isNaN(pageNum) || pageNum < 1) {
        pageNum = 1;
      } else if (pageNum > totalPages) {
        pageNum = totalPages;
      }

      setCounter(pageNum);
      setInputVal(pageNum.toString());
    }
  };

  return (
    <div className='container'>
      <div className='d-flex justify-content-between align-items-center'>
        <button type='button' className='btn btn-primary btn-sm' onClick={() => onClickButton('first')}>
          First-Page
        </button>

        <div className='d-flex align-items-center'>
          <button type='button' className='btn btn-secondary btn-sm ms-2 me-2' onClick={() => onClickButton('prev')}>
            Previous
          </button>

          {/* Direct Editable Page Input Box */}
          <div className='d-flex align-items-center me-2 ms-2'>
            <input
              type="number"
              className="form-control text-center shadow-none fw-bold"
              style={{ width: '60px', height: '31px', padding: '2px' }}
              min="1"
              max={totalPages}
              value={inputVal}
              onChange={handlePageInputChange}
              onKeyDown={handlePageSubmit}
              onBlur={handlePageSubmit}
            />
            <span className="ms-2 text-muted fw-semibold" style={{ fontSize: '13px' }}>
              / {totalPages}
            </span>
          </div>

          <button type='button' className='btn btn-secondary btn-sm ms-2 me-2' onClick={() => onClickButton('next')}>
            Next
          </button>
        </div>

        <button type='button' className='btn btn-primary btn-sm ms-2' onClick={() => onClickButton('last')}>
          Last-Page
        </button>
      </div>
    </div>
  );
};

export default Pagination;